// @ts-nocheck
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { gridGapStyles } from "@store/Themes/common/mixins/grid";
import { spacingStyles } from "@store/Themes/common/mixins/spacing";
import { css } from "styled-components";

export interface AttributesProps {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    innerWrapper?: InjectableCss;
    item?: GridItemProps;
    label?: TypographyPresentationProps;
    value?: TypographyPresentationProps;
}

export const attributeSpacing = pxToRem(3);

export const baseStyles = () => css`
    color: ${getColor("text.main") /* Store Custom Code */};

    ${({ theme }) => css`
        font-size: ${theme.design.typography.size.smallest};
        line-height: ${theme.design.typography.lineHeight.semi};
    `}
`;

export const attributesProps: AttributesProps = {
    wrapper: {
        css: css`
            display: block;
            ${baseStyles()}
        `,
    },
    container: {
        gap: 0,
        css: css`
            ${gridGapStyles([], [attributeSpacing])}
            ${baseStyles()}
        `,
    },
    innerWrapper: {
        css: css`
            display: block;
            ${spacingStyles(null, attributeSpacing)}
        `,
    },
    item: {
        width: 12,
        css: css`
            flex-flow: wrap;
        `,
    },
    label: {
        css: css`
            margin-right: 0.3em;
        `,
    },
    value: {
        css: css`
            word-break: break-all;
        `,
    },
};
